import { Observable, from } from 'rxjs'
import { mergeMap } from 'rxjs/operators'


export const mergeMapAsync = <I, R>(cb: (event: I) => Promise<R>) => (subject$: Observable<I>): Observable<R> => {
  return subject$.pipe(
    mergeMap((event) => from(cb(event)))
  )
}
